module.exports = __webpack_public_path__ + "img/truckHead-grey.2c912be3.svg";